import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { HazardTechnicalReports, PropertyReportHazards } from '../types'
import { fetchHazardTechnicalReports } from '@app/services/propertyService'

export const useFetchHazardTechnicalReports = (reportHazards: PropertyReportHazards | null) => {
  // Extract scenario IDs from reportHazards - logic from old context
  const scenarioIds = useMemo(() => {
    if (!reportHazards || reportHazards.length === 0) return []
    return reportHazards.flatMap((h) => h.hazards.flatMap((hazard) => hazard.scenarios))
  }, [reportHazards])

  return useQuery<HazardTechnicalReports>({
    queryKey: ['hazardTechnicalReports', scenarioIds],
    queryFn: ({ signal }) => fetchHazardTechnicalReports(scenarioIds, signal),
    enabled: scenarioIds.length > 0,
    staleTime: 5 * 60 * 1000,
  })
}
